import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const testimonials = [
    {
      rating: 5.0,
      quote: "Fireline transformed my Porsche 911 beyond my expectations. The finished product was flawless and the attention to detail is unmatched. This is true craftsmanship.",
      name: "Michael Richardson",
      vehicle: "2023 Porsche 911 Turbo S",
      image: "https://public.readdy.ai/ai/img_res/1a206e3045939c28d63016cf64f6e23d.jpg"
    },
    {
      rating: 5.0,
      quote: "As a car collector, I'm extremely particular about who touches my vehicles. Fireline's services brought my vintage Ferrari back to showroom condition. Absolutely phenomenal work.",
      name: "David Chen",
      vehicle: "1985 Ferrari Testarossa",
      image: "https://readdy.ai/api/search-image?query=asian%20businessman%20portrait%20professional%20luxury%20car%20owner%20sophisticated%20clean%20background%20high%20quality&width=80&height=80&seq=testimonial2&orientation=squarish"
    },
    {
      rating: 5.0,
      quote: "The interior detailing on my Range Rover was incredible. Every surface looks brand new. The team's professionalism and dedication to perfection is why I keep coming back.",
      name: "Sarah Martinez",
      vehicle: "2024 Range Rover Autobiography",
      image: "https://readdy.ai/api/search-image?query=professional%20businesswoman%20portrait%20confident%20elegant%20luxury%20vehicle%20owner%20clean%20background%20high%20quality&width=80&height=80&seq=testimonial3&orientation=squarish"
    }
  ];

  const aboutImages = [
    {
      url: "https://readdy.ai/api/search-image?query=professional%20firefighter%20in%20uniform%20standing%20beside%20luxury%20exotic%20sports%20car%20in%20modern%20detailing%20facility%20symbolic%20dedication%20service%20premium%20automotive%20care%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter7&orientation=squarish",
      alt: "Firefighter with Luxury Vehicle",
      title: "Firefighter & Luxury Car"
    },
    {
      url: "https://readdy.ai/api/search-image?query=firefighter%20boots%20and%20professional%20car%20detailing%20supplies%20arranged%20together%20on%20luxury%20vehicle%20surface%20symbolic%20hard%20work%20dedication%20premium%20automotive%20service%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter8&orientation=squarish",
      alt: "Firefighter Boots with Detailing Supplies",
      title: "Boots & Detailing Supplies"
    },
    {
      url: "https://readdy.ai/api/search-image?query=close%20up%20firefighter%20hands%20wearing%20gloves%20holding%20premium%20car%20wax%20applicator%20luxury%20vehicle%20paint%20reflection%20symbolic%20precision%20craftsmanship%20dedication%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter9&orientation=squarish",
      alt: "Firefighter Hands Detailing",
      title: "Hands-On Precision Work"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20station%20number%20badge%20emblem%20on%20luxury%20sports%20car%20door%20panel%20premium%20automotive%20detailing%20symbolic%20service%20excellence%20dedication%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter10&orientation=squarish",
      alt: "Station Badge on Luxury Car",
      title: "Station Badge Display"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20turnout%20gear%20hanging%20in%20professional%20auto%20detailing%20garage%20luxury%20vehicles%20background%20symbolic%20dual%20dedication%20service%20excellence%20clean%20modern%20facility%20artistic%20composition&width=600&height=600&seq=aboutfirefighter11&orientation=squarish",
      alt: "Turnout Gear in Detailing Garage",
      title: "Gear in Detailing Facility"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20helmet%20visor%20reflecting%20luxury%20exotic%20car%20glossy%20paint%20surface%20premium%20automotive%20detailing%20symbolic%20protection%20care%20dedication%20clean%20background%20artistic%20composition%20close%20up&width=600&height=600&seq=aboutfirefighter12&orientation=squarish",
      alt: "Helmet Visor Reflection",
      title: "Helmet Visor Car Reflection"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20radio%20communication%20device%20next%20to%20luxury%20car%20detailing%20products%20premium%20automotive%20care%20tools%20symbolic%20dedication%20service%20excellence%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter13&orientation=squarish",
      alt: "Radio with Detailing Products",
      title: "Radio & Detailing Tools"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20maltese%20cross%20emblem%20luxury%20sports%20car%20hood%20ornament%20premium%20automotive%20detailing%20symbolic%20heroic%20service%20dedication%20excellence%20clean%20background%20artistic%20composition%20close%20up%20detail&width=600&height=600&seq=aboutfirefighter14&orientation=squarish",
      alt: "Maltese Cross on Luxury Car",
      title: "Maltese Cross Emblem"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20work%20gloves%20and%20microfiber%20detailing%20towels%20arranged%20on%20luxury%20vehicle%20paint%20surface%20symbolic%20precision%20care%20dedication%20premium%20automotive%20service%20clean%20background%20artistic%20composition&width=600&height=600&seq=aboutfirefighter15&orientation=squarish",
      alt: "Gloves & Microfiber Towels",
      title: "Work Gloves & Towels"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Firefighter%20name%20tag%20badge%20on%20luxury%20car%20leather%20interior%20seat%20premium%20automotive%20detailing%20symbolic%20personal%20dedication%20service%20excellence%20clean%20background%20artistic%20composition%20close%20up&width=600&height=600&seq=aboutfirefighter16&orientation=squarish",
      alt: "Name Badge on Leather Interior",
      title: "Name Badge Display"
    }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5qs4s0tu5df1co4dbu0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      if (response.ok) {
        alert('Thank you for your message! We\'ll get back to you within 24 hours.');
        form.reset();
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5qs4s0tu5df1co4dbug', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      if (response.ok) {
        alert('Successfully subscribed to our newsletter!');
        form.reset();
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  const eliteDetailImages = [
    {
      url: "https://readdy.ai/api/search-image?query=professional%20auto%20detailer%20carefully%20applying%20ceramic%20coating%20to%20luxury%20sports%20car%20glossy%20black%20paint%20surface%20with%20applicator%20pad%20premium%20automotive%20protection%20service%20elite%20detailing%20clean%20simple%20background%20close%20up%20detail%20shot%20meticulous%20precision%20work&width=400&height=320&seq=eliteoption1ceramic&orientation=portrait",
      title: "Ceramic Coating Application"
    },
    {
      url: "https://readdy.ai/api/search-image?query=professional%20detailer%20using%20dual%20action%20polisher%20machine%20on%20luxury%20car%20paint%20surface%20paint%20correction%20swirl%20removal%20elite%20automotive%20detailing%20service%20clean%20simple%20background%20close%20up%20detail%20shot%20premium%20equipment&width=400&height=320&seq=eliteoption2polisher&orientation=portrait",
      title: "Paint Correction Polishing"
    },
    {
      url: "https://readdy.ai/api/search-image?query=luxury%20exotic%20car%20engine%20bay%20perfectly%20detailed%20clean%20pristine%20premium%20automotive%20detailing%20elite%20service%20professional%20care%20clean%20simple%20background%20high%20quality%20close%20up%20shot&width=400&height=320&seq=eliteoption3engine&orientation=portrait",
      title: "Engine Bay Detailing"
    },
    {
      url: "https://readdy.ai/api/search-image?query=professional%20detailer%20inspecting%20luxury%20car%20paint%20surface%20with%20bright%20LED%20inspection%20light%20checking%20for%20imperfections%20elite%20automotive%20detailing%20quality%20control%20clean%20simple%20background%20close%20up%20detail%20shot&width=400&height=320&seq=eliteoption4inspection&orientation=portrait",
      title: "Paint Inspection"
    },
    {
      url: "https://readdy.ai/api/search-image?query=professional%20detailer%20carefully%20drying%20luxury%20exotic%20sports%20car%20with%20premium%20microfiber%20towel%20after%20wash%20meticulous%20precision%20elite%20automotive%20detailing%20service%20clean%20simple%20background%20close%20up%20detail%20shot&width=400&height=320&seq=eliteoption5drying&orientation=portrait",
      title: "Premium Drying Process"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/c1b90f4a8b2b32870df41807576309e2/9c36d4458cffb9b76294eda6a6f3920f.png" 
            alt="Fireline Auto Detailing" 
            className="h-16 sm:h-24 md:h-28"
          />
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer text-white hover:text-orange-500`}>Services</button>
            <button onClick={() => scrollToSection('portfolio')} className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer text-white hover:text-orange-500`}>Portfolio</button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer text-white hover:text-orange-500`}>About</button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer text-white hover:text-orange-500`}>Testimonials</button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer text-white hover:text-orange-500`}>Contact</button>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => scrollToSection('contact')} className="hidden sm:block px-4 sm:px-6 py-2 sm:py-2.5 border-2 border-orange-500 text-orange-500 rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wide hover:bg-orange-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
              Book Now
            </button>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-orange-500 cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black border-t border-gray-800 shadow-lg">
            <div className="px-4 py-4 space-y-3">
              <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-white hover:text-orange-500 font-medium cursor-pointer">Services</button>
              <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left py-2 text-white hover:text-orange-500 font-medium cursor-pointer">Portfolio</button>
              <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-white hover:text-orange-500 font-medium cursor-pointer">About</button>
              <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left py-2 text-white hover:text-orange-500 font-medium cursor-pointer">Testimonials</button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-white hover:text-orange-500 font-medium cursor-pointer">Contact</button>
              <button onClick={() => scrollToSection('contact')} className="w-full mt-2 px-6 py-2.5 border-2 border-orange-500 text-orange-500 rounded-full text-sm font-semibold uppercase tracking-wide hover:bg-orange-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                Book Now
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="https://readdy.ai/api/search-image?query=luxury%20sports%20car%20glossy%20black%20paint%20surface%20reflecting%20dramatic%20studio%20lighting%20close%20up%20detail%20shot%20premium%20automotive%20finish%20high%20contrast%20professional%20photography%20sleek%20modern%20aesthetic&width=1920&height=1080&seq=hero1&orientation=landscape" 
            alt="Luxury Auto Detailing" 
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            ELEVATED<br />AUTOMOTIVE<br />CARE
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-10 font-light max-w-2xl mx-auto px-4">
            Preservation-focused detailing by firefighter-owned professionals committed to precision.
          </p>
          <button onClick={() => scrollToSection('services')} className="px-6 sm:px-10 py-3 sm:py-4 bg-orange-500 text-white rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-600 transition-all inline-flex items-center gap-2 sm:gap-3 cursor-pointer whitespace-nowrap">
            Explore Services
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </button>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-20">
            <div className="inline-block px-4 sm:px-6 py-2 bg-orange-500 text-black rounded-full text-xs font-bold uppercase tracking-wider mb-4 sm:mb-6">
              Our Services
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">Premium Detailing Packages</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
              Tailored solutions for every vehicle, from essential maintenance to complete transformation
            </p>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            {/* Essential Detail */}
            <div className="group cursor-pointer">
              <div className="rounded-3xl overflow-hidden mb-6 h-64 sm:h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=luxury%20car%20exterior%20hand%20washing%20foam%20soap%20bubbles%20professional%20auto%20detailing%20service%20clean%20simple%20white%20background%20premium%20automotive%20care%20close%20up%20detail%20shot&width=400&height=320&seq=service1&orientation=portrait" 
                  alt="Essential Detail" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-4">Essential Detail</h3>
                <p className="text-3xl sm:text-4xl font-bold text-orange-500 text-center mb-6">$199</p>
                <ul className="space-y-3 mb-8 text-sm sm:text-base text-gray-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Hand-applied exterior wash & controlled dry</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Wheel & tire refinement</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Interior cabin refresh</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Interior & exterior glass polishing</span>
                  </li>
                </ul>
                <button onClick={() => scrollToSection('contact')} className="w-full py-3 sm:py-3.5 bg-orange-500 text-white rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap">
                  Select Package
                </button>
              </div>
            </div>

            {/* Premium Detail */}
            <div className="group cursor-pointer">
              <div className="rounded-3xl overflow-hidden mb-6 h-64 sm:h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=luxury%20car%20interior%20leather%20seats%20professional%20detailing%20cleaning%20premium%20automotive%20upholstery%20care%20clean%20simple%20background%20high%20quality%20close%20up%20detail%20shot&width=400&height=320&seq=service2&orientation=portrait" 
                  alt="Premium Detail" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-4">Premium Detail</h3>
                <p className="text-3xl sm:text-4xl font-bold text-orange-500 text-center mb-6">$299</p>
                <ul className="space-y-3 mb-8 text-sm sm:text-base text-gray-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Everything in the Essential Detail</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Enhanced exterior surface care</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Interior deep clean & detailing</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Leather conditioning & interior protection</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Refined tire & trim finish</span>
                  </li>
                </ul>
                <button onClick={() => scrollToSection('contact')} className="w-full py-3 sm:py-3.5 border-2 border-orange-500 text-orange-500 rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-500 hover:text-white transition-all cursor-pointer whitespace-nowrap">
                  Select Package
                </button>
              </div>
            </div>

            {/* Elite Detail */}
            <div className="group cursor-pointer sm:col-span-2 md:col-span-1">
              <div className="rounded-3xl overflow-hidden mb-6 h-64 sm:h-80">
                <img 
                  src={eliteDetailImages[0].url}
                  alt="Elite Detail" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-4">Elite Detail</h3>
                <p className="text-3xl sm:text-4xl font-bold text-orange-500 text-center mb-6">$399</p>
                <ul className="space-y-3 mb-8 text-sm sm:text-base text-gray-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Everything in the Premium Detail</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Extended hand detail & vehicle refinement</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Engine bay presentation detail</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Headlight clarity enhancement</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-500 text-xl mt-0.5 flex-shrink-0"></i>
                    <span>Final presentation touches</span>
                  </li>
                </ul>
                <button onClick={() => scrollToSection('contact')} className="w-full py-3 sm:py-3.5 border-2 border-orange-500 text-orange-500 rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-500 hover:text-white transition-all cursor-pointer whitespace-nowrap">
                  Select Package
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-gray-900">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-20">
            <div className="inline-block px-4 sm:px-6 py-2 bg-orange-500 text-black rounded-full text-xs font-bold uppercase tracking-wider mb-4 sm:mb-6">
              Our Work
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-4 sm:mb-6 px-4">Transformation Gallery</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl mx-auto px-4">
              Witness the precision and artistry that goes into every detail
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6 mb-8 sm:mb-12">
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-48 sm:h-80">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20sports%20car%20glossy%20black%20paint%20perfect%20reflection%20after%20professional%20detailing%20ceramic%20coating%20finish%20premium%20automotive%20care%20simple%20clean%20background%20high%20quality&width=400&height=320&seq=portfolio1&orientation=portrait" 
                alt="Portfolio 1" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-56 sm:h-96">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20car%20interior%20pristine%20leather%20seats%20dashboard%20perfect%20condition%20after%20detailing%20premium%20automotive%20upholstery%20simple%20clean%20background%20high%20quality&width=400&height=384&seq=portfolio2&orientation=portrait" 
                alt="Portfolio 2" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-48 sm:h-80 col-span-2 md:col-span-1">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20car%20wheel%20rim%20chrome%20finish%20perfect%20shine%20after%20professional%20detailing%20premium%20automotive%20care%20simple%20clean%20background%20high%20quality&width=400&height=320&seq=portfolio3&orientation=portrait" 
                alt="Portfolio 3" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-56 sm:h-96 col-span-2 md:col-span-1">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20car%20headlight%20crystal%20clear%20restoration%20professional%20detailing%20premium%20automotive%20lighting%20simple%20clean%20background%20high%20quality%20close%20up%20detail&width=400&height=384&seq=portfolio4&orientation=portrait" 
                alt="Portfolio 4" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-48 sm:h-80">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20car%20engine%20bay%20clean%20detailed%20professional%20automotive%20detailing%20premium%20care%20simple%20clean%20background%20high%20quality&width=400&height=320&seq=portfolio5&orientation=portrait" 
                alt="Portfolio 5" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="group cursor-pointer overflow-hidden rounded-xl sm:rounded-2xl h-56 sm:h-96">
              <img 
                src="https://readdy.ai/api/search-image?query=luxury%20car%20paint%20correction%20swirl%20marks%20removal%20before%20after%20professional%20detailing%20premium%20automotive%20finish%20simple%20clean%20background%20high%20quality&width=400&height=384&seq=portfolio6&orientation=portrait" 
                alt="Portfolio 6" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          </div>

          <div className="text-center">
            <button className="text-orange-500 font-semibold inline-flex items-center gap-2 hover:gap-4 transition-all cursor-pointer text-sm sm:text-base">
              View Full Portfolio
              <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
            <div className="relative order-2 md:order-1">
              <div className="rounded-3xl sm:rounded-[40px] overflow-hidden shadow-2xl h-[400px] sm:h-[500px] md:h-[600px]">
                <img 
                  src={aboutImages[2].url} 
                  alt={aboutImages[2].alt}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="inline-block px-4 sm:px-6 py-2 bg-orange-500 text-black rounded-full text-xs font-bold uppercase tracking-wider mb-4 sm:mb-6">
                About Fireline
              </div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
                Precision in Every Detail
              </h2>
              <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-600 leading-relaxed mb-6 sm:mb-10">
                <p>
                  Founded by a career firefighter, Fireline Auto Detailing is built on discipline, precision, and respect for craftsmanship. Every vehicle is approached with the same focus and attention demanded in public service.
                </p>
                <p>
                  We specialize in preservation-focused detailing for luxury and exotic automobiles, using refined techniques and premium products to maintain originality and elevate presentation.
                </p>
                <p>
                  Fireline operates by appointment only, servicing a limited number of vehicles to ensure uncompromising quality.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-10">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                    <i className="ri-award-line text-white text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-base sm:text-lg">10+ Years</p>
                    <p className="text-gray-600 text-xs sm:text-sm">Experience</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-base sm:text-lg">Certified</p>
                    <p className="text-gray-600 text-xs sm:text-sm">Professionals</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                    <i className="ri-star-line text-white text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-base sm:text-lg">Premium</p>
                    <p className="text-gray-600 text-xs sm:text-sm">Products Used</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                    <i className="ri-heart-line text-white text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-base sm:text-lg">100%</p>
                    <p className="text-gray-600 text-xs sm:text-sm">Satisfaction</p>
                  </div>
                </div>
              </div>
              <button className="px-6 sm:px-8 py-3 sm:py-3.5 border-2 border-orange-500 text-orange-500 rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-500 hover:text-white transition-all inline-flex items-center gap-2 sm:gap-3 cursor-pointer whitespace-nowrap">
                Learn More
                <i className="ri-arrow-right-up-line text-lg sm:text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-20">
            <div className="inline-block px-4 sm:px-6 py-2 bg-orange-500 text-black rounded-full text-xs font-bold uppercase tracking-wider mb-4 sm:mb-6">
              Testimonials
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">What Our Clients Say</h2>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-10 md:p-16 relative">
              <div className="inline-flex items-center gap-2 bg-gray-900 text-orange-500 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-6 sm:mb-8">
                <i className="ri-star-fill text-sm sm:text-base"></i>
                <span className="font-bold text-sm sm:text-base">{testimonials[currentTestimonial].rating}</span>
              </div>
              <div className="mb-8 sm:mb-12">
                <i className="ri-double-quotes-l text-4xl sm:text-6xl text-orange-500 opacity-20 absolute top-8 sm:top-12 left-6 sm:left-12"></i>
                <p className="text-lg sm:text-2xl md:text-3xl text-gray-800 leading-relaxed font-light relative z-10">
                  {testimonials[currentTestimonial].quote}
                </p>
              </div>
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div className="flex items-center gap-3 sm:gap-4">
                  <img 
                    src={testimonials[currentTestimonial].image} 
                    alt={testimonials[currentTestimonial].name} 
                    className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="font-bold text-gray-900 text-base sm:text-lg">{testimonials[currentTestimonial].name}</p>
                    <p className="text-gray-600 text-sm sm:text-base">{testimonials[currentTestimonial].vehicle}</p>
                  </div>
                </div>
                <div className="flex gap-3 sm:gap-4 self-end sm:self-auto">
                  <button 
                    onClick={() => setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                    className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-orange-500 text-orange-500 rounded-lg hover:bg-orange-500 hover:text-white transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
                  </button>
                  <button 
                    onClick={() => setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)}
                    className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-gray-900">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 sm:gap-16 md:gap-20">
            {/* Contact Info */}
            <div>
              <img 
                src="https://static.readdy.ai/image/c1b90f4a8b2b32870df41807576309e2/9c36d4458cffb9b76294eda6a6f3920f.png" 
                alt="Fireline Auto Detailing" 
                className="h-24 sm:h-32 md:h-40 mb-8 sm:mb-12"
              />
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8 sm:mb-12 md:mb-16">Get In Touch</h2>
              
              <div className="space-y-8 sm:space-y-12">
                <div>
                  <p className="text-orange-500 text-xs font-bold uppercase tracking-wider mb-2 sm:mb-3">Location</p>
                  <p className="text-white text-base sm:text-lg">
                    Miami, Florida
                  </p>
                </div>
                
                <div>
                  <p className="text-orange-500 text-xs font-bold uppercase tracking-wider mb-2 sm:mb-3">Phone</p>
                  <a href="tel:+17864538787" className="text-white text-base sm:text-lg hover:text-orange-500 transition-colors">
                    (786) 453-8787
                  </a>
                </div>
                
                <div>
                  <p className="text-orange-500 text-xs font-bold uppercase tracking-wider mb-2 sm:mb-3">Email</p>
                  <a href="mailto:info@firelinedetailing.com" className="text-white text-base sm:text-lg hover:text-orange-500 transition-colors break-all">
                    info@firelinedetailing.com
                  </a>
                </div>
                
                <div>
                  <p className="text-orange-500 text-xs font-bold uppercase tracking-wider mb-2 sm:mb-3">Hours</p>
                  <p className="text-white text-base sm:text-lg">
                    Flexible Scheduling • Appointment Only<br />
                    Availability is confirmed in advance.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 sm:gap-5 mt-12 sm:mt-16">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg sm:text-xl"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-lg sm:text-xl"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-youtube-fill text-lg sm:text-xl"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-linkedin-fill text-lg sm:text-xl"></i>
                </a>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-gray-800 rounded-3xl p-6 sm:p-8 md:p-10" data-readdy-form>
              <form id="contact-form" className="space-y-5 sm:space-y-6" onSubmit={handleContactSubmit}>
                <div>
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Your Name" 
                    required
                    className="w-full bg-transparent border-b-2 border-orange-500 text-white placeholder-gray-500 py-2.5 sm:py-3 text-sm sm:text-base focus:outline-none focus:border-orange-400 transition-colors"
                  />
                </div>
                <div>
                  <input 
                    type="email" 
                    name="email"
                    placeholder="Email Address" 
                    required
                    className="w-full bg-transparent border-b-2 border-orange-500 text-white placeholder-gray-500 py-2.5 sm:py-3 text-sm sm:text-base focus:outline-none focus:border-orange-400 transition-colors"
                  />
                </div>
                <div>
                  <input 
                    type="tel" 
                    name="phone"
                    placeholder="Phone Number" 
                    required
                    className="w-full bg-transparent border-b-2 border-orange-500 text-white placeholder-gray-500 py-2.5 sm:py-3 text-sm sm:text-base focus:outline-none focus:border-orange-400 transition-colors"
                  />
                </div>
                <div>
                  <select 
                    name="service"
                    required
                    className="w-full bg-transparent border-b-2 border-orange-500 text-white py-2.5 sm:py-3 text-sm sm:text-base focus:outline-none focus:border-orange-400 transition-colors"
                  >
                    <option value="" className="bg-gray-800">Select Service</option>
                    <option value="Essential Detail" className="bg-gray-800">Essential Detail - $199</option>
                    <option value="Premium Detail" className="bg-gray-800">Premium Detail - $299</option>
                    <option value="Elite Detail" className="bg-gray-800">Elite Detail - $399</option>
                    <option value="Custom Quote" className="bg-gray-800">Custom Quote</option>
                  </select>
                </div>
                <div>
                  <textarea 
                    name="message"
                    placeholder="Tell us about your vehicle and needs" 
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full bg-transparent border-b-2 border-orange-500 text-white placeholder-gray-500 py-2.5 sm:py-3 text-sm sm:text-base focus:outline-none focus:border-orange-400 transition-colors resize-none"
                  ></textarea>
                  <p className="text-gray-500 text-xs">Maximum 500 characters</p>
                </div>
                <button 
                  type="submit"
                  className="w-full py-3 sm:py-4 bg-orange-500 text-white rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-600 transition-all inline-flex items-center justify-center gap-2 sm:gap-3 cursor-pointer whitespace-nowrap"
                >
                  Send Message
                  <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
                </button>
                <p className="text-gray-500 text-xs sm:text-sm text-center">We'll respond within 24 hours</p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border-t border-orange-500 py-12 sm:py-16 md:py-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10 sm:gap-12 md:gap-16 mb-12 sm:mb-16">
            {/* Brand */}
            <div>
              <img 
                src="https://static.readdy.ai/image/c1b90f4a8b2b32870df41807576309e2/9c36d4458cffb9b76294eda6a6f3920f.png" 
                alt="Fireline Auto Detailing" 
                className="h-24 sm:h-32 md:h-36 mb-4 sm:mb-6"
              />
              <p className="text-gray-500 text-xs sm:text-sm text-center md:text-left">
                © 2024 Fireline Auto Detailing. All rights reserved.
              </p>
              <div className="flex gap-3 sm:gap-4">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-instagram-line text-base sm:text-lg"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-base sm:text-lg"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-youtube-fill text-base sm:text-lg"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-orange-500 text-orange-500 rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer">
                  <i className="ri-linkedin-fill text-base sm:text-lg"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white text-xs sm:text-sm font-bold uppercase tracking-wider mb-4 sm:mb-6">Quick Links</h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base">
                <li><button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Services</button></li>
                <li><button onClick={() => scrollToSection('portfolio')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Portfolio</button></li>
                <li><button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">About</button></li>
                <li><button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Testimonials</button></li>
                <li><button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Contact</button></li>
                <li><button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Booking</button></li>
              </ul>
            </div>

            {/* Newsletter */}
            <div className="sm:col-span-2 md:col-span-1">
              <h4 className="text-white text-xs sm:text-sm font-bold uppercase tracking-wider mb-4 sm:mb-6">Newsletter</h4>
              <p className="text-gray-500 text-sm sm:text-base mb-4 sm:mb-6">Stay updated on detailing tips and special offers</p>
              <form className="space-y-3 sm:space-y-4" data-readdy-form id="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <input 
                  type="email" 
                  name="email"
                  placeholder="Your email address" 
                  required
                  className="w-full bg-gray-900 border border-orange-500 text-white placeholder-gray-500 px-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-full focus:outline-none focus:border-orange-400 transition-colors"
                />
                <button 
                  type="submit"
                  className="w-full py-2.5 sm:py-3 bg-orange-500 text-white rounded-full text-sm sm:text-base font-bold uppercase tracking-wide hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div className="border-t border-orange-500 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-xs sm:text-sm text-center md:text-left">
              © 2024 Fireline Auto Detailing. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
              <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-orange-500 transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
